import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { USD } from '../../constants/currency-codes';
import globalSelectors from '../../store/global-selectors';
import { useSellerWallets } from '../use-seller-wallets';

export const useBalancePurchase = (purchasePostageProp, tracking, onAddFundsComplete, closeModal) => {
  const sellerWallets = useSellerWallets();
  const sellerCurrencyCode = useSelector(globalSelectors.selectSellerDefaultCurrency) || USD;
  return useCallback(
    (providers, insurances, walletedProviderGroups) => {
      const nonWalletedProviderPurchases = providers.filter((provider) => !provider.walletId);
      const nonWalletedInsurancePurchases = insurances.filter((provider) => !provider.walletId);

      const walletPurchaseInfo = Object.values(walletedProviderGroups)
        .filter((walletPurchaseList) => walletPurchaseList[0].purchaseAmount)
        .map((walletPurchaseList) => {
          return {
            walletId: `${walletPurchaseList[0].walletId}`,
            walletPurchaseAmount: {
              value: walletPurchaseList[0].purchaseAmount,
              code:
                sellerWallets.find((wallet) => wallet.walletId === `${walletPurchaseList[0].walletId}`)?.currencyCode ?? sellerCurrencyCode,
            },
          };
        });

      purchasePostageProp(
        nonWalletedProviderPurchases,
        nonWalletedInsurancePurchases,
        walletPurchaseInfo,
        tracking,
        onAddFundsComplete,
        closeModal,
      );
    },
    [purchasePostageProp, tracking, onAddFundsComplete, closeModal, sellerWallets, sellerCurrencyCode],
  );
};
